import { gql } from '@apollo/client'
import React from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useProcessState = () => React.useContext(Context)
export const useProcess = () => useProcessState()?.screen

const QUERY = gql`
  query Screen($id: ID) {
    screen(id: $id) {
      id
      name
      screen
      data
      userGroups
    }
  }
`

const ProcessesLoader = ({ children }) => {
  const { id } = useModalData() || {}

  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: generalClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ProcessesLoader
